var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _vm.planningLoad
        ? _c(
            "v-dialog",
            {
              attrs: { lazy: "", persistent: "", "max-width": "500" },
              on: {
                input: function(v) {
                  return v
                }
              },
              model: {
                value: _vm.showDispatchToNetworkDialog,
                callback: function($$v) {
                  _vm.showDispatchToNetworkDialog = $$v
                },
                expression: "showDispatchToNetworkDialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-4" },
                [
                  _c("span", { staticClass: "title mb-3" }, [
                    _vm._v("Dispatch to Carrier Network")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { attrs: { "two-line": "" } },
                    [
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-content",
                            [
                              _vm.planningLoadCustomerName
                                ? _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n              Customer: " +
                                        _vm._s(_vm.planningLoadCustomerName) +
                                        "\n            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-sub-title",
                                { staticClass: "font-italic" },
                                [
                                  _vm._v(
                                    "\n              Bills $" +
                                      _vm._s(_vm.billableAmount) +
                                      " for " +
                                      _vm._s(
                                        _vm.distanceLabel(_vm.loadedMiles)
                                      ) +
                                      ", $" +
                                      _vm._s(_vm.loadedDistanceBilledRate) +
                                      "\n              per loaded " +
                                      _vm._s(_vm.siteDistanceMeasureUnitLabel) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-sub-title",
                                { staticClass: "font-italic" },
                                [
                                  _vm._v(
                                    "\n              Based on Google Maps\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.planningLoadCustomerName
                        ? _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-avatar",
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      "prepend-icon": _vm.includeCustomerIcon
                                    },
                                    model: {
                                      value: _vm.includeCustomerOnDispatch,
                                      callback: function($$v) {
                                        _vm.includeCustomerOnDispatch = $$v
                                      },
                                      expression: "includeCustomerOnDispatch"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.includeCustomerOnDispatchLabel
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-sub-title",
                                    { staticClass: "font-italic" },
                                    [
                                      _vm._v(
                                        "\n              customer is hidden from dispatched subhauler\n            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-sub-title",
                                    { staticClass: "font-italic" },
                                    [
                                      _vm._v(
                                        "\n              unless checked\n            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        { staticClass: "pt-3" },
                        [
                          _c(
                            "v-list-tile-action",
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "Visible load count",
                                  items: _vm._.range(
                                    1,
                                    1 + _vm.planningLoad.loadGroup.loadCount
                                  )
                                },
                                model: {
                                  value: _vm.visibleCount,
                                  callback: function($$v) {
                                    _vm.visibleCount = $$v
                                  },
                                  expression: "visibleCount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-float-field", {
                                attrs: { label: "Payable Amount ($)" },
                                model: {
                                  value: _vm.dispatchPayableAmount,
                                  callback: function($$v) {
                                    _vm.dispatchPayableAmount = $$v
                                  },
                                  expression: "dispatchPayableAmount"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-content",
                            [
                              _c(
                                "v-list-tile-sub-title",
                                { staticClass: "font-italic" },
                                [
                                  _vm._v(
                                    "\n              $" +
                                      _vm._s(
                                        _vm.billableAmount -
                                          _vm.dispatchPayableAmount
                                      ) +
                                      " spread per load\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-sub-title",
                                { staticClass: "font-italic" },
                                [
                                  _vm._v(
                                    "\n              Pays " +
                                      _vm._s(
                                        _vm.distanceLabel(_vm.loadedMiles)
                                      ) +
                                      ", $" +
                                      _vm._s(_vm.loadedDistancePaidRate) +
                                      " per loaded " +
                                      _vm._s(_vm.siteDistanceMeasureUnitLabel) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-sub-title",
                                { staticClass: "font-italic" },
                                [
                                  _vm._v(
                                    "\n              Based on Google Maps\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-list-tile-avatar",
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  "prepend-icon": _vm.bookLoadAssignments
                                    ? "schedule"
                                    : "access_time_filled"
                                },
                                model: {
                                  value: _vm.bookLoadAssignments,
                                  callback: function($$v) {
                                    _vm.bookLoadAssignments = $$v
                                  },
                                  expression: "bookLoadAssignments"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  "\n              Book assignment immediately\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-sub-title",
                                { staticClass: "font-italic" },
                                [
                                  _vm._v(
                                    "\n              load not booked until company accepts dispatch offer\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-sub-title",
                                { staticClass: "font-italic" },
                                [
                                  _vm._v(
                                    "\n              unless checked\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-select",
                            {
                              attrs: {
                                items: _vm.cdnMembers,
                                "item-text": "companyName",
                                "item-value": "companyId",
                                label:
                                  "Select Preferred Carrier" +
                                  (_vm.bookLoadAssignments ? "" : "s"),
                                "menu-props":
                                  "{ closeOnContentClick: true, closeOnClick: true }",
                                multiple: !_vm.bookLoadAssignments
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "selection",
                                    fn: function(ref) {
                                      var item = ref.item
                                      var index = ref.index
                                      return [
                                        index === 0
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(item.companyName) +
                                                  "\n                "
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        index === 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "grey--text caption ml-2"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  (+" +
                                                    _vm._s(
                                                      _vm.selectedMembers
                                                        .length - 1
                                                    ) +
                                                    " others)\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                568519409
                              ),
                              model: {
                                value: _vm.selectedMembers,
                                callback: function($$v) {
                                  _vm.selectedMembers = $$v
                                },
                                expression: "selectedMembers"
                              }
                            },
                            [
                              !_vm.bookLoadAssignments
                                ? _c(
                                    "v-list-tile",
                                    {
                                      attrs: {
                                        slot: "prepend-item",
                                        ripple: ""
                                      },
                                      on: { click: _vm.selectAllCDNMembers },
                                      slot: "prepend-item"
                                    },
                                    [
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c("v-icon", [
                                            _vm._v(_vm._s(_vm.icon))
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-tile-title", [_vm._v("All")])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.bookLoadAssignments
                                ? _c("v-divider", {
                                    staticClass: "mt-2",
                                    attrs: { slot: "prepend-item" },
                                    slot: "prepend-item"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.bookLoadAssignments
                                ? _c("v-divider", {
                                    staticClass: "mb-2",
                                    attrs: { slot: "append-item" },
                                    slot: "append-item"
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer", { staticClass: "mt-3" }),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "accent",
                            disabled: !_vm.dispatchPayableAmount,
                            loading: _vm.loadingBtn
                          },
                          on: { click: _vm.dispatchLoad }
                        },
                        [_vm._v("\n          Dispatch\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent", flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.resetDispatchToNetworkDialog()
                            }
                          }
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.planningLoad && _vm.isLoadboardEnabled
        ? _c(
            "v-dialog",
            {
              attrs: {
                "full-width": !_vm.isMobile,
                "max-width": "500",
                lazy: ""
              },
              model: {
                value: _vm.showPostToLoadBoardDialog,
                callback: function($$v) {
                  _vm.showPostToLoadBoardDialog = $$v
                },
                expression: "showPostToLoadBoardDialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-4" },
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        [
                          _c("v-text-field", {
                            attrs: {
                              step: 1,
                              min: 1,
                              max: _vm.planningLoad.loadGroup.loadCount,
                              type: "number",
                              label: "Visible load count"
                            },
                            model: {
                              value: _vm.visibleCount,
                              callback: function($$v) {
                                _vm.visibleCount = $$v
                              },
                              expression: "visibleCount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._.get(
                    _vm.planningLoad,
                    "loadGroup.details.customerCompany"
                  )
                    ? [
                        _c("span", { staticClass: "title mb-3" }, [
                          _vm._v(
                            "\n          Would you like to include the customer on the Load Details page and " +
                              _vm._s(_vm.$t("terms.bill-of-lading")) +
                              "?\n        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("i", [
                          _vm._v(
                            "Customer: " + _vm._s(_vm.planningLoadCustomerName)
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "accent",
                                  fab: "",
                                  small: "",
                                  flat: ""
                                },
                                on: {
                                  click: function($event) {
                                    _vm.showLiveLoadBoardInfoDialog = true
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("help_outline")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "accent",
                                  loading: _vm.loadingBtn,
                                  disabled: _vm.errors.any("modal")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.postToLoadBoard(true)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { staticClass: "pr-2" }, [
                                  _vm._v("person_add")
                                ]),
                                _vm._v("\n            Yes\n          ")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "accent",
                                  loading: _vm.loadingBtn,
                                  disabled: _vm.errors.any("modal")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.postToLoadBoard(false)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { staticClass: "pr-2" }, [
                                  _vm._v("person_add_disabled")
                                ]),
                                _vm._v("\n            No\n          ")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "accent", flat: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.resetPostToLoadBoardDialog()
                                  }
                                }
                              },
                              [_vm._v("\n            Cancel\n          ")]
                            )
                          ],
                          1
                        )
                      ]
                    : _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                loading: _vm.loadingBtn
                              },
                              on: {
                                click: function($event) {
                                  return _vm.postToLoadBoard(false)
                                }
                              }
                            },
                            [
                              _c("v-icon", { staticClass: "pr-2" }, [
                                _vm._v("gavel")
                              ]),
                              _vm._v(
                                "\n          Post to Live Load Board\n        "
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "accent", flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.resetPostToLoadBoardDialog()
                                }
                              }
                            },
                            [_vm._v("\n          Cancel\n        ")]
                          )
                        ],
                        1
                      )
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("assign-truck-dialog", {
        attrs: { company: _vm.company, load: _vm.planningLoad },
        on: {
          refresh: function($event) {
            return _vm.updateLoad($event)
          }
        },
        model: {
          value: _vm.showAssignTrucksDialog,
          callback: function($$v) {
            _vm.showAssignTrucksDialog = $$v
          },
          expression: "showAssignTrucksDialog"
        }
      }),
      _vm._v(" "),
      _c("vendor-dispatch-dialog", {
        attrs: { company: _vm.company, load: _vm.planningLoad },
        on: {
          refresh: function($event) {
            return _vm.updateLoad($event)
          }
        },
        model: {
          value: _vm.showAssignVendorDialog,
          callback: function($$v) {
            _vm.showAssignVendorDialog = $$v
          },
          expression: "showAssignVendorDialog"
        }
      }),
      _vm._v(" "),
      _c("assign-truck-dialog", {
        attrs: {
          company: _vm.company,
          load: _vm.planningLoad,
          "outside-trucks": true
        },
        on: {
          refresh: function($event) {
            return _vm.updateLoad($event)
          }
        },
        model: {
          value: _vm.showOutsideAssignmentDialog,
          callback: function($$v) {
            _vm.showOutsideAssignmentDialog = $$v
          },
          expression: "showOutsideAssignmentDialog"
        }
      }),
      _vm._v(" "),
      _vm.isLoadboardEnabled
        ? _c(
            "v-dialog",
            {
              attrs: { "full-width": !_vm.isMobile, "max-width": "500" },
              model: {
                value: _vm.showLiveLoadBoardInfoDialog,
                callback: function($$v) {
                  _vm.showLiveLoadBoardInfoDialog = $$v
                },
                expression: "showLiveLoadBoardInfoDialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-4" },
                [
                  _c("span", { staticClass: "title mb-3" }, [
                    _vm._v("Live Load Board Post")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n      Post a listing to the live Load Board and start getting bids from available haulers.\n      "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n      If you select a bid from the live Load Board, the resulting booked load optionally will\n      include the customer.  If it is your load, you are the customer and you will be on it.\n      "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "title mb-3" }, [
                    _vm._v("Dispatched Loads")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n      If this load is for a customer, you can optionally remove the customer's visibility when you\n      post to the Load Board.\n      "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v("person_add")
                  ]),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Include Customer.")]),
                  _vm._v(
                    " When a customer is included,\n      they will have access to the Load Details page and will be on the " +
                      _vm._s(_vm.$t("terms.bill-of-lading")) +
                      ". They will\n      receive updates and notifications as well.\n      "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v("person_add_disabled")
                  ]),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Customer not Included.")]),
                  _vm._v(
                    " If a customer is not included on the load, they will\n      not be able to follow progress on the Load Details page, they will not receive updates or\n      notifications, and they will not be on the " +
                      _vm._s(_vm.$t("terms.bill-of-lading")) +
                      ".\n      "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "\n      If it is posted, you can remove the posting, which means you will no longer get new bids.\n      You can always post it again if you need to.\n\n      "
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.showLiveLoadBoardInfoDialog = false
                            }
                          }
                        },
                        [_vm._v("\n          Got It\n        ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "full-width": !_vm.isMobile, "max-width": "500" },
          model: {
            value: _vm.showCarrierNetworkInfoDialog,
            callback: function($$v) {
              _vm.showCarrierNetworkInfoDialog = $$v
            },
            expression: "showCarrierNetworkInfoDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c("span", { staticClass: "title mb-3" }, [
                _vm._v("Preferred Carrier Assignment")
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n      Send a request to all or some members of your Carrier Network at a price you set, optionally\n      including the customer on the load and " +
                  _vm._s(_vm.$t("terms.bill-of-lading")) +
                  ".\n      "
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "accent", flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showCarrierNetworkInfoDialog = false
                        }
                      }
                    },
                    [_vm._v("\n          Got It\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.planningLoad
        ? _c("v-repeat-load-group-dialog", {
            attrs: {
              loadGroupId: _vm.loadGroup.humanId,
              sponsor: _vm.loadGroupSponsorName(_vm.loadGroup),
              origin: _vm._f("originName")(_vm.loadGroup.details),
              destination: _vm._f("destinationName")(_vm.loadGroup.details),
              count: _vm.loadGroup.loadCount || 1,
              isMobile: _vm.isMobile,
              loading: _vm.loadingBtn,
              company: _vm.company,
              "load-group": _vm.loadGroup
            },
            on: {
              cancel: _vm.closeCopyLoadDialog,
              newLoad: function($event) {
                return _vm.closeCopyLoadDialog(true)
              }
            },
            model: {
              value: _vm.showCopyLoadDialog,
              callback: function($$v) {
                _vm.showCopyLoadDialog = $$v
              },
              expression: "showCopyLoadDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.planningLoad
        ? _c(
            "v-load-group-details",
            {
              attrs: {
                planning: "",
                "read-only": _vm.detailsEditModeReadOnly,
                "banner-title": "The Planning Tool™",
                "planning-load": _vm.planningLoad,
                loading: _vm.loading,
                company: _vm.company
              },
              on: {
                reload: function($event) {
                  return _vm.$emit("reload")
                },
                onFormChange: function($event) {
                  return _vm.$emit("onFormChange", $event)
                },
                savingLoad: function($event) {
                  return _vm.updateSavingState($event)
                },
                updateLoad: function($event) {
                  return _vm.$emit("updateLoad", $event)
                },
                cancelLoad: function($event) {
                  return _vm.$emit("cancelLoad", $event)
                }
              }
            },
            [
              _c(
                "template",
                { slot: "toolbarButtons" },
                [
                  _vm.detailsEditModeReadOnly
                    ? _c(
                        "v-btn",
                        {
                          attrs: { flat: "", color: "accent" },
                          on: { click: _vm.toggleDetailsEditMode }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c("v-icon", [_vm._v("edit")]),
                              _vm._v("\n          Edit\n        ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.detailsEditModeReadOnly
                    ? [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              flat: "",
                              color: "accent",
                              disabled: _vm.loading
                            },
                            on: { click: _vm.assignTrucksDialog }
                          },
                          [
                            _c(
                              "v-layout",
                              { attrs: { column: "" } },
                              [
                                _c("v-icon", [_vm._v("headset_mic")]),
                                _vm._v(
                                  "\n            Direct Dispatch\n          "
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.isQuickbooksConnected(_vm.company)
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  flat: "",
                                  color: "accent",
                                  disabled:
                                    _vm.loading ||
                                    !_vm.shouldUseQuickbooks(_vm.company)
                                },
                                on: { click: _vm.assignVendorDialog }
                              },
                              [
                                _c("v-layout", { attrs: { column: "" } }, [
                                  _c("img", {
                                    staticClass: "mx-auto",
                                    attrs: {
                                      height: "24",
                                      width: "24",
                                      src: "/static/Quickbooks-Logo.png"
                                    }
                                  }),
                                  _vm._v(
                                    "\n            Vendor Dispatch\n          "
                                  )
                                ])
                              ],
                              1
                            )
                          : _c(
                              "v-btn",
                              {
                                attrs: {
                                  flat: "",
                                  color: "accent",
                                  disabled: _vm.loading
                                },
                                on: { click: _vm.noteOutsideAssignmentDialog }
                              },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { column: "" } },
                                  [
                                    _c("v-icon", [_vm._v("phonelink_ring")]),
                                    _vm._v(
                                      "\n            Phone Dispatch\n          "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                      ]
                    : [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              flat: "",
                              color: "accent",
                              disabled: _vm.savingLoad
                            },
                            on: { click: _vm.toggleDetailsEditMode }
                          },
                          [
                            _c(
                              "v-layout",
                              { attrs: { column: "" } },
                              [
                                _c("v-icon", [_vm._v("clear")]),
                                _vm._v("\n            Ignore\n          ")
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "accent", loading: _vm.savingLoad },
                            on: { click: _vm.saveDetailsUpdates }
                          },
                          [
                            _c(
                              "v-layout",
                              { attrs: { column: "" } },
                              [
                                _c("v-icon", [_vm._v("save")]),
                                _vm._v("\n            Save\n          ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                  _vm._v(" "),
                  _vm.detailsEditModeReadOnly
                    ? _c(
                        "v-btn",
                        {
                          attrs: { flat: "", color: "accent" },
                          on: { click: _vm.openCopyLoadDialog }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c("v-icon", [_vm._v("redo")]),
                              _vm._v("\n          Repeat\n        ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "dispatchTab" },
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: {
                        extended: _vm.isMobile,
                        dense: !_vm.isMobile,
                        flat: ""
                      }
                    },
                    [
                      _vm.isMobile
                        ? _c(
                            "v-toolbar-title",
                            [
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { "align-self-center": "" } },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.visibleDispatchRequests.length
                                          ) +
                                          " dispatch " +
                                          _vm._s(
                                            _vm._f("pluralize")(
                                              _vm.visibleDispatchRequests
                                                .length,
                                              "request"
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass:
                                        "text-sm-right text-xs-right",
                                      attrs: { "align-self-center": "" }
                                    },
                                    [
                                      _c(
                                        "v-btn-toggle",
                                        { attrs: { multiple: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              model: {
                                                value:
                                                  _vm.showCanceledNetworkRequests,
                                                callback: function($$v) {
                                                  _vm.showCanceledNetworkRequests = $$v
                                                },
                                                expression:
                                                  "showCanceledNetworkRequests"
                                              }
                                            },
                                            [
                                              _vm.showCanceledNetworkRequests
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { color: "accent" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    highlight_off\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _c("v-icon", [
                                                    _vm._v("highlight_off")
                                                  ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            flat: "",
                                            fab: "",
                                            small: "",
                                            color: "primary"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              on: {
                                                click: function($event) {
                                                  _vm.showCarrierNetworkInfoDialog = true
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  help_outline\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c("v-toolbar-title", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.visibleDispatchRequests.length) +
                                " dispatch " +
                                _vm._s(
                                  _vm._f("pluralize")(
                                    _vm.visibleDispatchRequests.length,
                                    "request"
                                  )
                                ) +
                                "\n        "
                            )
                          ]),
                      _vm._v(" "),
                      _vm.isMobile
                        ? _c(
                            "template",
                            { slot: "extension" },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "accent", flat: "" },
                                          on: {
                                            click: _vm.dispatchToNetworkDialog
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "pr-2" },
                                            [_vm._v("share")]
                                          ),
                                          _vm._v(
                                            "\n                Send Network Request\n              "
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : [
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "accent", flat: "" },
                                on: { click: _vm.dispatchToNetworkDialog }
                              },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { column: "" } },
                                  [
                                    _c("v-icon", { staticClass: "pr-2" }, [
                                      _vm._v("share")
                                    ]),
                                    _vm._v(
                                      "\n              Send Network Request\n            "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn-toggle",
                              { attrs: { multiple: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    model: {
                                      value: _vm.showCanceledNetworkRequests,
                                      callback: function($$v) {
                                        _vm.showCanceledNetworkRequests = $$v
                                      },
                                      expression: "showCanceledNetworkRequests"
                                    }
                                  },
                                  [
                                    _vm.showCanceledNetworkRequests
                                      ? _c(
                                          "v-icon",
                                          { attrs: { color: "accent" } },
                                          [
                                            _vm._v(
                                              "\n                highlight_off\n              "
                                            )
                                          ]
                                        )
                                      : _c("v-icon", [_vm._v("highlight_off")])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      fab: "",
                                      small: "",
                                      color: "primary"
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        on: {
                                          click: function($event) {
                                            _vm.showCarrierNetworkInfoDialog = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                help_outline\n              "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            column: _vm.isMobile,
                            row: !_vm.isMobile,
                            wrap: !_vm.isMobile,
                            "align-start": "",
                            "justify-start": ""
                          }
                        },
                        _vm._l(_vm.visibleDispatchRequests, function(dispatch) {
                          return _vm.planningLoad &&
                            _vm.visibleDispatchRequests.length > 0
                            ? _c(
                                "v-flex",
                                {
                                  key: "dispatch_" + dispatch.humanId,
                                  attrs: { xs4: "" }
                                },
                                [
                                  _c("v-dispatch-request", {
                                    key: dispatch.humanId,
                                    attrs: {
                                      dispatch: dispatch,
                                      load: _vm.planningLoad
                                    },
                                    on: {
                                      refreshLoad: function($event) {
                                        return _vm.refreshLoad()
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.isLoadboardEnabled
                ? _c(
                    "template",
                    { slot: "liveLoadBoardTab" },
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            extended: _vm.isMobile,
                            dense: !_vm.isMobile,
                            flat: ""
                          }
                        },
                        [
                          _c("v-toolbar-title", [
                            _vm._v(
                              "\n          Live Load Board Activity\n        "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.isMobile
                            ? _c(
                                "template",
                                { slot: "extension" },
                                [
                                  _vm.isPostedToLiveLoadBoard(_vm.planningLoad)
                                    ? _c("v-text-field", {
                                        staticClass:
                                          "single-line hide-details mb-0 pr-2",
                                        attrs: {
                                          "append-icon": "search",
                                          label: "Search bids"
                                        },
                                        model: {
                                          value: _vm.bidSearch,
                                          callback: function($$v) {
                                            _vm.bidSearch = $$v
                                          },
                                          expression: "bidSearch"
                                        }
                                      })
                                    : _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "accent", flat: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.postToLoadBoardDialog(
                                                _vm.planningLoad
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { column: "" } },
                                            [
                                              _c(
                                                "v-icon",
                                                { staticClass: "pr-2" },
                                                [_vm._v("gavel")]
                                              ),
                                              _vm._v(
                                                "\n              Post to Live Load Board\n            "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                  _vm._v(" "),
                                  _vm.isPostedToLiveLoadBoard(_vm.planningLoad)
                                    ? _c(
                                        "v-btn-toggle",
                                        { attrs: { multiple: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              model: {
                                                value:
                                                  _vm.showCanceledLoadBoardBids,
                                                callback: function($$v) {
                                                  _vm.showCanceledLoadBoardBids = $$v
                                                },
                                                expression:
                                                  "showCanceledLoadBoardBids"
                                              }
                                            },
                                            [
                                              _vm.showCanceledLoadBoardBids
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { color: "accent" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                highlight_off"
                                                      )
                                                    ]
                                                  )
                                                : _c("v-icon", [
                                                    _vm._v("highlight_off")
                                                  ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              model: {
                                                value:
                                                  _vm.showAcceptedLoadBoardBids,
                                                callback: function($$v) {
                                                  _vm.showAcceptedLoadBoardBids = $$v
                                                },
                                                expression:
                                                  "showAcceptedLoadBoardBids"
                                              }
                                            },
                                            [
                                              _vm.showAcceptedLoadBoardBids
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { color: "accent" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                done"
                                                      )
                                                    ]
                                                  )
                                                : _c("v-icon", [_vm._v("done")])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        flat: "",
                                        fab: "",
                                        small: "",
                                        color: "primary"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.showLiveLoadBoardInfoDialog = true
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              help_outline\n            "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : [
                                _c("v-spacer"),
                                _vm._v(" "),
                                _vm.isPostedToLiveLoadBoard(_vm.planningLoad)
                                  ? _c("v-text-field", {
                                      staticClass:
                                        "single-line hide-details mb-0 pr-2",
                                      attrs: {
                                        "append-icon": "search",
                                        label: "Search bids"
                                      },
                                      model: {
                                        value: _vm.bidSearch,
                                        callback: function($$v) {
                                          _vm.bidSearch = $$v
                                        },
                                        expression: "bidSearch"
                                      }
                                    })
                                  : _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "accent", flat: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.postToLoadBoardDialog(
                                              _vm.planningLoad
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-layout",
                                          { attrs: { column: "" } },
                                          [
                                            _c(
                                              "v-icon",
                                              { staticClass: "pr-2" },
                                              [_vm._v("gavel")]
                                            ),
                                            _vm._v(
                                              "\n              Post to Live Load Board\n            "
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                _vm._v(" "),
                                _vm.isPostedToLiveLoadBoard(_vm.planningLoad)
                                  ? _c(
                                      "v-btn-toggle",
                                      { attrs: { multiple: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            model: {
                                              value:
                                                _vm.showCanceledLoadBoardBids,
                                              callback: function($$v) {
                                                _vm.showCanceledLoadBoardBids = $$v
                                              },
                                              expression:
                                                "showCanceledLoadBoardBids"
                                            }
                                          },
                                          [
                                            _vm.showCanceledLoadBoardBids
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    attrs: { color: "accent" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                highlight_off"
                                                    )
                                                  ]
                                                )
                                              : _c("v-icon", [
                                                  _vm._v("highlight_off")
                                                ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            model: {
                                              value:
                                                _vm.showAcceptedLoadBoardBids,
                                              callback: function($$v) {
                                                _vm.showAcceptedLoadBoardBids = $$v
                                              },
                                              expression:
                                                "showAcceptedLoadBoardBids"
                                            }
                                          },
                                          [
                                            _vm.showAcceptedLoadBoardBids
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    attrs: { color: "accent" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                done"
                                                    )
                                                  ]
                                                )
                                              : _c("v-icon", [_vm._v("done")])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      fab: "",
                                      small: "",
                                      color: "primary"
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        on: {
                                          click: function($event) {
                                            _vm.showLiveLoadBoardInfoDialog = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              help_outline\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.isLoadboardEnabled &&
                      _vm.isPostedToLiveLoadBoard(_vm.planningLoad)
                        ? _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "", "mt-2": "" } },
                            [
                              _c(
                                "v-card",
                                { staticClass: "ml-2 mr-3 mb-3" },
                                [
                                  _c(
                                    "v-container",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-toolbar",
                                        {
                                          staticClass: "ml-0",
                                          attrs: { card: "", dense: "" }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "primary" } },
                                            [_vm._v("gavel")]
                                          ),
                                          _vm._v(" "),
                                          _c("v-toolbar-title", [
                                            _vm._v(
                                              "\n                Accepting Bids\n              "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: { color: "accent" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeFromLoadBoard(
                                                    _vm.planningLoad
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                cancel\n              "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        [
                                          _vm.planningLoad.customerCompany
                                            ? _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-action",
                                                    [
                                                      _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            color: "primary",
                                                            "text-color":
                                                              "white",
                                                            small: ""
                                                          }
                                                        },
                                                        [
                                                          _vm.planningLoad
                                                            .loadBoard
                                                            .includeCustomer
                                                            ? _c("v-icon", [
                                                                _vm._v(
                                                                  "person_add"
                                                                )
                                                              ])
                                                            : _c("v-icon", [
                                                                _vm._v(
                                                                  "person_add_disabled"
                                                                )
                                                              ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _vm._v("Customer "),
                                                        !_vm.planningLoad
                                                          .loadBoard
                                                          .includeCustomer
                                                          ? _c("span", [
                                                              _vm._v("not")
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" included")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile-sub-title",
                                                        [
                                                          _vm._v(
                                                            "on the Load Details and " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "terms.bill-of-lading"
                                                                )
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.planningLoad.customerCompany
                                            ? _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-action",
                                                    [
                                                      _c(
                                                        "v-chip",
                                                        {
                                                          attrs: {
                                                            color: "primary",
                                                            "text-color":
                                                              "white",
                                                            small: ""
                                                          }
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "monetization_on"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _vm.planningLoad
                                                        .billableAmount != null
                                                        ? _c(
                                                            "v-list-tile-title",
                                                            [
                                                              _vm._v(
                                                                "\n                    Pays $" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .planningLoad
                                                                      .billableAmount
                                                                  ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          )
                                                        : _c(
                                                            "v-list-tile-title",
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font-weight-bold font-italic"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Missing billing amount"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.planningLoad.customerCompany
                                            ? _c(
                                                "v-list-tile",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "\n                  This is your load\n                "
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        "text-color": "white",
                                                        small: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("list")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "\n                    Posted to Live Load Board\n                  "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm._f("formatDate")(
                                                            _vm.planningLoad
                                                              .loadBoard
                                                              .published
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        color: "primary"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "white"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      add_shopping_cart\n                    "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.allBids.length
                                                      ) + " bids"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.activeBids.length
                                                      ) + " active"
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        "text-color": "white",
                                                        small: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("visibility")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.planningLoad
                                                            .loadBoard
                                                            .visibleCount
                                                        ) +
                                                        " visible\n                    " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "pluralize"
                                                          )(
                                                            _vm.planningLoad
                                                              .loadBoard
                                                              .visibleCount,
                                                            "load",
                                                            {
                                                              includeNumber: false
                                                            }
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.bids, function(bid) {
                                return _c("v-bid-card", {
                                  key: "bid_card_" + bid.humanId,
                                  attrs: { bid: bid, load: _vm.planningLoad },
                                  on: {
                                    refresh: function($event) {
                                      return _vm.onRefresh()
                                    }
                                  }
                                })
                              })
                            ],
                            2
                          )
                        : _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "", "mt-2": "" } },
                            [
                              _c(
                                "v-card",
                                { staticClass: "ma-3" },
                                [
                                  _c(
                                    "v-container",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-toolbar",
                                        {
                                          staticClass: "ml-0",
                                          attrs: { card: "", dense: "" }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "primary" } },
                                            [_vm._v("gavel")]
                                          ),
                                          _vm._v(" "),
                                          _c("v-toolbar-title", [
                                            _vm._v(
                                              "\n                Post to Live Board\n              "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: { color: "accent" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.postToLoadBoardDialog(
                                                    _vm.planningLoad
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                add_circle\n              "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        [
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "\n                    Find an Outside Truck\n                  "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      "\n                    Get bids from " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "site-title.brief"
                                                          )
                                                        ) +
                                                        "'s available, qualified carriers\n                  "
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "template",
                { slot: "loadMap" },
                [
                  _vm.planningLoad
                    ? _c("load-map", {
                        staticClass: "py-1 px-1",
                        attrs: {
                          hideOnSmall: "",
                          "origin-place-id": _vm._.get(
                            _vm.planningLoad,
                            "loadGroup.details.pickupLocation.googlePlace.placeId",
                            null
                          ),
                          "destination-place-id": _vm._.get(
                            _vm.planningLoad,
                            "loadGroup.details.dropoffLocation.googlePlace.placeId",
                            null
                          )
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bf32eca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bf32eca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/simple/PlannedLoadGroupDetails.vue
// module id = null
// module chunks = 